var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0C5389"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1998 26.0004V20.6004C25.1998 18.0801 25.1998 16.82 24.7093 15.8574C24.2779 15.0107 23.5895 14.3223 22.7428 13.8909C21.7802 13.4004 20.5201 13.4004 17.9998 13.4004C15.4796 13.4004 14.2195 13.4004 13.2568 13.8909C12.4101 14.3223 11.7217 15.0107 11.2903 15.8574C10.7998 16.82 10.7998 18.0801 10.7998 20.6004V26.0004",
    stroke: "white",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6992 15.9336C21.8061 15.9336 22.7061 16.7932 22.6657 17.9002",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26H27",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8V10.7",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1 10.7012L24.75 12.0512",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90039 10.7012L11.2504 12.0512",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3504 21.9496C19.3504 22.6952 18.746 23.2996 18.0004 23.2996C17.2548 23.2996 16.6504 22.6952 16.6504 21.9496C16.6504 21.204 17.2548 20.5996 18.0004 20.5996C18.746 20.5996 19.3504 21.204 19.3504 21.9496Z",
    stroke: "white",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.2988V25.9988",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L27 27",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoval);
export default __webpack_public_path__ + "static/media/Removal.52add517d1db0bb15002a8bd006c7387.svg";
export { ForwardRef as ReactComponent };